import { AppLanguage, getPreferredLanguage } from '../language';

export interface AddressBookI18nTemplate {
  ui: {
    actionMyAddresses: string;
    actionLoginNow: string;
    dropdownEdit: string;
    dropdownCopy: string;
    dropdownDelete: string;
    addressLandingDescription: string;
    addressTagDefault: string;
    addressFilterAllTypes: string;
    addressFilterTypeDefault: string;
    addressFilterTypeNormal: string;
    addressFilterAllStates: string;
    addressSearchPlaceholder: string;
    addressActionAdd: string;
    addressActionShipNow: string;
    addressDrawerTitleEdit: string;
    addressDrawerTitleAdd: string;
    addressDrawerActionDone: string;
    addressDrawerSectionAddress: string;
    addressDrawerSectionOther: string;
    addressDrawerSetDefaultShipping: string;
    addressDrawerSaveFailed: string;
  };
}

export const TEMPLATES: Record<AppLanguage, AddressBookI18nTemplate> = {
  zh: {
    ui: {
      actionMyAddresses: '我的地址',
      actionLoginNow: '立即登录',
      dropdownEdit: '编辑',
      dropdownCopy: '复制',
      dropdownDelete: '删除',
      addressLandingDescription: '管理常用发货地址。',
      addressTagDefault: '默认',
      addressFilterAllTypes: '所有类型',
      addressFilterTypeDefault: '默认地址',
      addressFilterTypeNormal: '普通地址',
      addressFilterAllStates: '所有州',
      addressSearchPlaceholder: '搜索姓名、电话、公司、备注名、街道、房号、城市、州、邮编、地址详情',
      addressActionAdd: '+ 地址',
      addressActionShipNow: '立即发货',
      addressDrawerTitleEdit: '编辑地址',
      addressDrawerTitleAdd: '新建地址',
      addressDrawerActionDone: '完成',
      addressDrawerSectionAddress: '地址',
      addressDrawerSectionOther: '其他',
      addressDrawerSetDefaultShipping: '设为默认发货地址',
      addressDrawerSaveFailed: '保存失败',
    },
  },
  en: {
    ui: {
      actionMyAddresses: 'My addresses',
      actionLoginNow: 'Log in now',
      dropdownEdit: 'Edit',
      dropdownCopy: 'Copy',
      dropdownDelete: 'Delete',
      addressLandingDescription: 'Manage your shipping addresses.',
      addressTagDefault: 'Default',
      addressFilterAllTypes: 'All types',
      addressFilterTypeDefault: 'Default address',
      addressFilterTypeNormal: 'Regular address',
      addressFilterAllStates: 'All states',
      addressSearchPlaceholder: 'Search name, phone, company, alias, street, unit, city, state, ZIP, address details',
      addressActionAdd: '+ Address',
      addressActionShipNow: 'Ship now',
      addressDrawerTitleEdit: 'Edit address',
      addressDrawerTitleAdd: 'Add address',
      addressDrawerActionDone: 'Done',
      addressDrawerSectionAddress: 'Address',
      addressDrawerSectionOther: 'Other',
      addressDrawerSetDefaultShipping: 'Set as default shipping address',
      addressDrawerSaveFailed: 'Save failed',
    },
  },
};

export const ADDRESS_BOOK_NAMESPACE = 'addressBook';

export const ADDRESS_BOOK_RESOURCE_KEY = 'template';

export const ADDRESS_BOOK_I18N_RESOURCES: Record<
  AppLanguage,
  Record<typeof ADDRESS_BOOK_RESOURCE_KEY, AddressBookI18nTemplate>
> = {
  zh: {
    [ADDRESS_BOOK_RESOURCE_KEY]: TEMPLATES.zh,
  },
  en: {
    [ADDRESS_BOOK_RESOURCE_KEY]: TEMPLATES.en,
  },
};

export const getAddressBookTemplate = (
  language: AppLanguage = getPreferredLanguage(),
): AddressBookI18nTemplate => TEMPLATES[language] || TEMPLATES.zh;
